<script lang="ts">
    import {clipboard} from '@skeletonlabs/skeleton';
    import toast from "svelte-french-toast";

    export let url;
    export let referralCode;

    let shareURL = '';

    $: {
        shareURL = new URL(url);
        if (referralCode) {
            shareURL.searchParams.set("referrer", referralCode);
        }
    }

    function showToast() {
        toast.success('Share link copied to clipboard!', {
            position: 'top-center',
            duration: 2000,
            icon: '📋',
        });
    }


</script>

<aside class="flex flex-col border-[1px] border-black rounded-xl p-5">
    <p class="font-bold mb-5">Know someone who lives here?</p>
    <p class="mb-3">
        Send this building to them so they can add their review! Even if they no longer live here, they can add their past experience.
    </p>
    <button use:clipboard={shareURL.toString()}
            on:click={showToast}
            class="btn variant-filled bg-black w-fit rounded-xl py-3 text-sm">
        Send to a friend
    </button>
</aside>
